import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["src"];
var _hoisted_2 = {
  class: "main-empty__description"
};
var _hoisted_3 = {
  key: 1
};
var _hoisted_4 = {
  key: 0,
  class: "common-empty__bottom"
};
import { computed } from 'vue';
import EmptyIcon from './empty.svg';
export default {
  __name: 'index',
  props: {
    size: {
      type: [Number, String],
      default: 150
    },
    text: {
      type: String,
      default: '暂无数据'
    },
    icon: {
      type: String,
      default: ''
    },
    fullHeight: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var sizeStyle = computed(function () {
      return {
        width: "".concat(props.size, "px"),
        height: 'auto'
      };
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["main-empty", {
          'full-height': __props.fullHeight
        }])
      }, [_createElementVNode("img", {
        src: props.icon || _unref(EmptyIcon),
        style: _normalizeStyle(sizeStyle.value)
      }, null, 12, _hoisted_1), _createElementVNode("div", _hoisted_2, [_ctx.$slots.description ? _renderSlot(_ctx.$slots, "description", {}, undefined, undefined, 0) : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(props.text), 1))]), _ctx.$slots.default ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_renderSlot(_ctx.$slots, "default")])) : _createCommentVNode("", true)], 2);
    };
  }
};